import { render, staticRenderFns } from "./NotificationAnnouncement2.vue?vue&type=template&id=721b3562&scoped=true&"
import script from "./NotificationAnnouncement2.vue?vue&type=script&lang=js&"
export * from "./NotificationAnnouncement2.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAnnouncement2.vue?vue&type=style&index=0&id=721b3562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b3562",
  null
  
)

export default component.exports